import { Loader } from 'pixi.js'

/**
 * 记载图片
 */
export class LoaderImage extends Loader {
  private imageArr: { name: string; path: string }[];
  private resolution: number;

  constructor (opt: {
    imageArr: { name: string; path: string }[];
    resolution: number;
  }) {
    super()
    this.imageArr = opt.imageArr
    this.resolution = opt.resolution
    this.addImgArr()
  }

  addImgArr () {
    this.imageArr.forEach((ele) => {
      super.add(ele.name, ele.path, {
        metadata: {
          resolution: this.resolution,
          resourceOptions: {
            scale: this.resolution
          }
        }
      })
    })
  }
}

/**
 * 渐变画布
 * @param opt 参数
 * @returns
 */
export function drawGradientCanvas (opt: {
  width: number;
  height: number;
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  colorStop: { offset: number; color: string }[];
}) {
  const canvas = document.createElement('canvas')

  canvas.width = opt.width
  canvas.height = opt.height

  const ctx = canvas.getContext('2d')

  if (ctx) {
    const bgColor = ctx.createLinearGradient(opt.x0, opt.y0, opt.x1, opt.y1)

    opt.colorStop.forEach((ele) => {
      bgColor.addColorStop(ele.offset, ele.color)
    })

    ctx.fillStyle = bgColor
    ctx.fillRect(0, 0, opt.width, opt.height)
  }

  return canvas
}
